<!--
 * @Descripttion: 
 * @Author: lijingjing56
 * @Date: 2024-08-09 13:59:22
 * @LastEditors: lijingjing56
 * @LastEditTime: 2024-12-19 14:30:18
-->
<template>
		<div class="cls-block">
      <section-title text="优秀合作伙伴榜单" mess="携手行业伙伴共建数智生态，榜单评选欢迎联系官邮：mktc@jd.com"/>
			<div class="cls-main-block">
					<img class="cls-middle-img" src="//img10.360buyimg.com/img/jfs/t1/224295/3/25081/381840/6760e2a7Fb346cb10/66aa19fe8fef5e89.png" />
			</div>
		</div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle.vue";
export default {
  name: "ProductSolution",
  data() {
    return {
     
    };
  },
  components: {
    sectionTitle
  }
};
</script>

<style lang="scss" scoped>
.cls-block {
  width: 100%;
  padding: 80px 0 74px;
  background: linear-gradient(180deg, rgba(240, 242, 255, 1) 0%, rgba(251, 252, 255, 1) 77.32%, rgba(255, 255, 255, 1) 100%);

  .cls-main-block {
    display: flex;
    justify-content: center;
    .cls-middle-img {
      width: 1200px;
      margin-top:40px;
    }
  }
}
</style>
